const SPACE_CHARACTERS = /[\u00A0\u202F ]/g;
const NFD_DIACRITICS = /[\u0300-\u036f]/g;
const HTTP_PROTOCOL_PREFIX = /^https?:\/\//;
// Footnote calls of a QPS question ("Index¹"). ¹ ² ³ are Latin-1 (U+00B9, U+00B2, U+00B3), the other
// superscript digits are in U+2070–U+2079. The capturing group puts the calls at odd indexes of split().
const QPS_NOTE_CALLS = /([¹²³⁰⁴-⁹]+)/;

export { SPACE_CHARACTERS, NFD_DIACRITICS, HTTP_PROTOCOL_PREFIX, QPS_NOTE_CALLS };
